import { type IconReference } from '@appsemble/lang-sdk';
import { Icon, Subtitle, Title } from '@appsemble/react-components';
import { type ElementType, type MouseEventHandler, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

import styles from './index.module.css';

interface ListButtonProps {
  readonly alt?: string;
  readonly description?: ReactNode;
  readonly icon?: IconReference;
  readonly image?: string;
  readonly onClick?: MouseEventHandler<HTMLButtonElement>;
  readonly subtitle?: ReactNode;
  readonly title?: ReactNode;
  readonly to?: string;
}

export function ListButton({
  alt,
  description,
  icon,
  image,
  onClick,
  subtitle,
  title,
  to,
}: ListButtonProps): ReactNode {
  const Wrapper: ElementType = to ? Link : 'button';
  const props = to ? { to } : ({ type: 'button', onClick } as const);

  return (
    <li className="my-4">
      <Wrapper className={`is-flex px-4 py-4 ${styles.wrapper}`} {...props}>
        <figure className={`image is-64x64 is-flex ${styles.figure}`}>
          {image ? (
            <img alt={alt} src={image} />
          ) : icon ? (
            <Icon color="dark" icon={icon} iconSize="3x" size="large" />
          ) : null}
        </figure>
        <div className={`ml-4 ${styles.content}`}>
          {title ? (
            <Title className="is-marginless" size={4}>
              {title}
            </Title>
          ) : null}
          {subtitle ? (
            <Subtitle className="is-marginless" size={5}>
              {subtitle}
            </Subtitle>
          ) : null}
          {description ? <span className="has-text-grey">{description}</span> : null}
        </div>
      </Wrapper>
    </li>
  );
}
